"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _index = require("../utils/index");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var NavBarHeader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(NavBarHeader, _PureComponent);

  function NavBarHeader() {
    _classCallCheck(this, NavBarHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(NavBarHeader).apply(this, arguments));
  }

  _createClass(NavBarHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          rootUrl = _this$props.rootUrl,
          logoUrl = _this$props.logoUrl,
          _this$props$logoAttri = _this$props.logoAttribute,
          logoAttribute = _this$props$logoAttri === void 0 ? {} : _this$props$logoAttri,
          onOpen = _this$props.onOpen,
          LogoComponent = _this$props.LogoComponent,
          LogoTitleComponent = _this$props.LogoTitleComponent,
          _this$props$titleEven = _this$props.titleEvent,
          titleEvent = _this$props$titleEven === void 0 ? {} : _this$props$titleEven,
          _this$props$logoEvent = _this$props.logoEvent,
          logoEvent = _this$props$logoEvent === void 0 ? {} : _this$props$logoEvent;
      var logoDom = null;
      var logoTitleDom = null;

      if (typeof LogoComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(LogoComponent)) {
          logoDom = LogoComponent;
        } else {
          logoDom = _react["default"].createElement(LogoComponent, _extends({
            href: rootUrl,
            className: "spaui-topnav-brand logo",
            type: "logo"
          }, (0, _index.getSupportEventMap)(logoEvent)), _react["default"].createElement("img", _extends({
            src: logoUrl
          }, logoAttribute)));
        }
      }

      if (typeof LogoTitleComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(LogoTitleComponent)) {
          logoTitleDom = LogoTitleComponent;
        } else {
          logoTitleDom = _react["default"].createElement(LogoTitleComponent, _extends({
            href: rootUrl,
            className: "spaui-topnav-title",
            type: "logo-title"
          }, (0, _index.getSupportEventMap)(titleEvent)), _react["default"].createElement("span", null, title));
        }
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: 'spaui-topnav-header',
        needTitle: false
      }), _react["default"].createElement("button", {
        type: "button",
        className: "spaui-topnav-toggler is-collapse",
        "data-toggle": "collapse",
        "data-target": "#std-spaui-topnav",
        "aria-expanded": "false",
        "aria-controls": "spaui-topnav",
        onClick: onOpen
      }, _react["default"].createElement("span", {
        className: "spaui-topnav-toggler-icon",
        title: "\u2630"
      }, _react["default"].createElement("span", {
        className: "spaui-topnav-hamb"
      }))), _react["default"].createElement("div", {
        className: "spaui-topnav-left"
      }, logoDom, _react["default"].createElement("span", {
        className: "spaui-topnav-divider"
      }), logoTitleDom));
    }
  }]);

  return NavBarHeader;
}(_react.PureComponent);

var _default = NavBarHeader;
exports["default"] = _default;